import { useInfiniteRequest } from '@space-shell/common/hooks/useInfiniteRequest'
import {
  CommunitiesEndpoints,
  CommunitiesService,
  TOTAL_ROWS_GET_COURSES
} from '@space-shell/common/services/communities'

export const useGetCourses = (membershipSlug: string, idCommunity: string) => {
  return useInfiniteRequest(
    [CommunitiesEndpoints.getCourses(membershipSlug)],
    ({ pageParam }) => CommunitiesService.getCourses(membershipSlug, idCommunity, pageParam),
    {
      getNextPageParam: (lastPage) => {
        const { content, totalElements, page } = lastPage

        if (content.length === 0 || totalElements <= TOTAL_ROWS_GET_COURSES) {
          return false
        }

        if (content.length === TOTAL_ROWS_GET_COURSES) {
          return page + 1
        }

        return undefined
      }
    }
  )
}
